import React, { useState } from 'react';
import './MoodGames.css';

/**
 * GroundExplorer — the 5-4-3-2-1 grounding walk, made interactive. Each step asks
 * you to notice things through one sense; tap the counter for each thing you find
 * until the step is complete, then move to the next. A calm, paced way to come back
 * to the present. Easy to leave at any point.
 */
const STEPS = [
  { n: 5, sense: 'things you can see', emoji: '👀' },
  { n: 4, sense: 'things you can feel', emoji: '✋' },
  { n: 3, sense: 'things you can hear', emoji: '👂' },
  { n: 2, sense: 'things you can smell', emoji: '👃' },
  { n: 1, sense: 'thing you can taste', emoji: '👅' },
];

export const GroundExplorer: React.FC = () => {
  const [step, setStep] = useState(0);
  const [found, setFound] = useState(0);
  const done = step >= STEPS.length;
  const cur = done ? null : STEPS[step];

  const tap = () => {
    if (!cur) return;
    const next = found + 1;
    if (next >= cur.n) {
      window.setTimeout(() => { setStep((s) => s + 1); setFound(0); }, 250);
      setFound(next);
    } else {
      setFound(next);
    }
  };

  const replay = () => { setStep(0); setFound(0); };

  return (
    <div className="mm-game mm-game--explore">
      <div className="mm-game__head">
        <h3 className="mm-game__title">5-4-3-2-1 Explorer</h3>
        <p className="mm-game__sub">Come back to your senses, one step at a time.</p>
      </div>

      {done || !cur ? (
        <div className="mm-game__done">
          <span className="mm-game__done-emoji">🪷</span>
          <span className="mm-game__done-title">You’re here, now.</span>
          <span className="mm-game__done-sub">Nicely grounded. Carry this calmer breath with you.</span>
          <button type="button" className="mm-game__btn mm-game__btn--ghost" onClick={replay}>Again</button>
        </div>
      ) : (
        <div className="mm-game__done" style={{ gap: 12 }}>
          <span className="mm-explore__count">{cur.n - found}</span>
          <span className="mm-explore__sense">{cur.emoji} Notice {cur.n} {cur.sense}</span>
          <div className="mm-explore__dots" aria-hidden="true">
            {Array.from({ length: cur.n }, (_, i) => (
              <span key={i} className={`mm-explore__dot ${i < found ? 'is-on' : ''}`} />
            ))}
          </div>
          <button type="button" className="mm-game__btn" onClick={tap}>I found one</button>
          <span className="mm-explore__progress">Step {step + 1} of {STEPS.length}</span>
        </div>
      )}
    </div>
  );
};

export default GroundExplorer;
